const loc = window.location;
export const { hostname } = loc;
export const staticHostname = 'files.ati.su';
export const helpHostname = `help.${hostname}`;
export const apiHostname = `api.${hostname}`;
